import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(75),
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#F9F9FD',
    boxShadow: theme.shadows[2],
    '& .MuiSnackbarContent-message': {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiCircularProgress-root': {
      color: theme.palette.primary.light,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.light,
    },
    '& .MuiTypography-root': {
      marginLeft: theme.spacing(3),
      color: theme.palette.grey[300],
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: theme.spacing(55),
    },
  },
}))

export default useStyles
